const apiAddress = 'https://siqqee-api.madtechet.com';

const constants = {
  apiUrl: `${apiAddress}/api`,
  mediaUrl: `${apiAddress}/media`,
  authUrl: 'auth-ea35a',
  keys: {
    user: 'user',
  },
  prefixes: {
    sorting: 'sorting',
    visibility: 'visibility',
    density: 'density',
    rowsPerPage: 'rows_per_page',
  },
};

export default constants;
